
export interface ISequence {
    Compare(seq: string): number;
    FireHandler(seq:string): void;
}

export class StringSequence implements ISequence {

    private sequence: string;
    private element: any;

    constructor(seq: string, element: any) {
        this.sequence = seq;
        this.element = element;
    }

    Compare(seq: string): number {
        if (this.sequence.startsWith(seq)) {
            if (seq.length == this.sequence.length)
                // Full Match
                return 0
            else
                // Matched with sequence remaining
                return 1;
        }

        // Did not match
        return -1;
    }

    FireHandler(seq:string): void {
        const e = new Event('shortkey', { bubbles: false });
        this.element.dispatchEvent(e)
    }
}

export class FmdCodeSequence implements ISequence{
    callback: (seq: string) => void;
    constructor(callback: (seq: string) => void) {
        this.callback = callback;
    }
    

    FireHandler(seq: string): void {
        if (this.callback) {
            this.callback(seq);
        }
    }

    public Compare(seq: string): number {
        if (seq.length == 50) {
            if (seq[0] == "0" &&
                seq[1] == "1" &&
                seq[16] == "1" &&
                seq[17] == "7" &&
                seq[24] == "1" &&
                seq[25] == "0" &&
                seq[34] == "4" &&
                seq[35] == "1" &&
                seq[36] == "0")
                return 0;
            else
                return -1;
        }
        else {
            if (
                (seq[0] == "0" || seq.length == 0) &&
                (seq[1] == "1" || seq.length < 2) &&
                (seq[16] == "1" || seq.length < 17) &&
                (seq[17] == "7" || seq.length < 18) &&
                (seq[24] == "1" || seq.length < 25) &&
                (seq[25] == "0" || seq.length < 26) &&
                (seq[34] == "4" || seq.length < 35) &&
                (seq[35] == "1" || seq.length < 36) &&
                (seq[36] == "0" || seq.length < 37)) {
                return 1;
            }
            else {
                return -1;
            }
        }
    }
}

export default class SequenceHandler {

    private _awaiting: boolean;
    private _currentSequence: string;
    private _prevCurrentSequence: string;
    private _remaingCommands: Array<ISequence>
    private _sequences: Array<ISequence>
    
    constructor(commands: Array<ISequence>) {
        this._sequences = commands;
    }

    public processKey(key: string) {

        var currentSequence = (this._currentSequence ? this._currentSequence + "," : "") + key;
        var matchingCommads = this.getMatchingCommands(currentSequence);

        if (matchingCommads.length == 0) {
            //console.warn("Sequence Handler - Processing key without match sequence : " + currentSequence, this._sequences);
            return -1;
        }

        if (matchingCommads.length == 1 && matchingCommads[0].Compare(currentSequence) == 0) {
            // Single Full Match
            console.log("Sequence Handler - sequence matched : " + currentSequence, this._sequences);
            this.fireEvent(matchingCommads[0]);
            this.reset();
            return 0;
        }

        // One or more partially matched sequences
        console.log("Sequence Handler - sequence partially matched : " + currentSequence, matchingCommads);
        this._awaiting = true;
        this._currentSequence = currentSequence;
        this._prevCurrentSequence = currentSequence;
        setTimeout(() => this.checkStatus(), 500)
        return 1;
    }

    private fireEvent(seq: ISequence) {
        seq.FireHandler(this._currentSequence);
    }

    private reset() {
        this._awaiting = false;
        this._currentSequence = this._prevCurrentSequence = "";
        this._remaingCommands = [];
    }

    private checkStatus() {
        if (this._awaiting) {
            if (this._prevCurrentSequence.length == this._currentSequence.length) {
                //No Change has occurred since last time - Timer has expired
                console.log("Timer expired awaiting furthter command to " + this._currentSequence);
                this.reset();

                //Fire any completed Sequence
                var matchingCommands = this._remaingCommands.filter(c => c.Compare(this._currentSequence) == 0)
                for (var command of matchingCommands) {
                    //Proces Event
                    this.fireEvent(command);
                }
            }
            else {
                setTimeout(() => this.checkStatus(),500)
            }
        }
    }

    private getMatchingCommands(currentSequence: string): Array<ISequence> {

        //var commands = this._awaiting ? this._remaingCommands : this._sequences;
        var commands = this._sequences;
        var result = commands.filter(c => c.Compare(currentSequence) >= 0);

        //console.log("result " + currentSequence, result, commands)
        return result;
    }
}




// WEBPACK FOOTER //
// ./ClientApp/scripts/sequenceHandler.ts